import Image from 'next/image';
import { useRouter } from 'next/navigation';

import { Text } from '@/components/atomic/nuclei';
import { staticMediaStoreBaseURL } from '@/config/common';
import {
  captureGTMEventCTAClick,
  GTM_EVENTS_CTA_NAME,
  PAGE_NAME
} from '@/lib/gtm';
import { PARTNER_PORTAL_URL } from '@/services/connections.service';

const BecomePartner = () => {
  const router = useRouter();
  return (
    <section className='relative w-full bg-become-partner-background-mobile bg-cover bg-center md:bg-become-partner-background-web'>
      <div className='max-w-7xl md:max-w-3xl tab:max-w-4xl lg:max-w-240 lg-l:max-w-5xl xl:max-w-6xl xl-1:max-w-6xl 2xl:max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 items-center px-4 xxxs:px-6 md:px-0 py-8 md:py-2 gap-y-8 md:gap-y-0'>
        <div className='order-1 md:order-2 relative flex justify-center md:justify-end mb-8 md:mb-0'>
          <Image
            alt='Partner Puzzle Illustration'
            className='w-full max-w-sm xs:max-w-md lg:max-w-lg'
            height={560}
            priority
            src={`${staticMediaStoreBaseURL}/home-page/partner-statistics.png`}
            width={604}
            style={{
              objectFit: 'contain',
              width: '100%',
              height: 'auto'
            }}
          />
        </div>
        <div className='order-2 md:order-1 text-center md:text-left mt-10 md:mt-0'>
          <div className='text-3xl xxxs:text-3xl tab:text-5xl lg:text-5xl lg-l:text-7xl font-black text-white leading-tight font-Montserrat text-stroke-normal md:text-stroke-bold tracking-wide'>
            Grow Your Business <br /> with Hafla
          </div>
          <div className='text-base xs:text-xl md:text-lg text-white max-w-md mx-auto md:mx-0 font-medium mt-2'>
            Access UAE’s largest AI-powered event marketplace and multiply your
            opportunities.
          </div>
          <div
            className='flex flex-row justify-center cursor-pointer rounded-full bg-white w-max z-10 py-2 px-4 sm:py-3 sm:px-6 md:px-9 md:py-4 mx-auto md:mx-0 md:mt-10 mt-7'
            onClick={() => {
              captureGTMEventCTAClick({
                ctaName: GTM_EVENTS_CTA_NAME.BECOME_PARTNER,
                pageName: PAGE_NAME.HOME_PAGE.label
              });
              router.push(PARTNER_PORTAL_URL);
            }}
          >
            <Text
              {...{
                className:
                  'font-google-basic text-15px md:text-xl font-medium text-black self-center tracking-widest',
                content: 'Become a Partner'
              }}
            />
            <div className='self-center ml-2'>
              <Image
                alt='arrow right'
                height={10}
                width={14}
                src={`${staticMediaStoreBaseURL}/icons/arrowright.svg`}
                style={{
                  width: '14px',
                  height: '10px',
                  objectFit: 'contain'
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BecomePartner;
